<template>
    <div class="mytable">
        <div class="row">
            <div class="col table-responsive">
                <table class="table mb-0" style="vertical-align:top" cellpadding="10" border="0">
            <tbody>
                <tr align="center">
                    <th></th>
                    <th><i>a</i></th>
                    <th><i>i</i></th>
                    <th><i>u</i></th>
                    <th><i>e</i></th>
                    <th><i>o</i></th>
                </tr>
                <tr align="center">
                    <th title="no lead consonant">∅</th>
                    <td>あ</td>
                    <td>い</td>
                    <td>う</td>
                    <td>え</td>
                    <td>お</td>
                </tr>
                <tr align="center">
                    <th><i>k</i></th>
                    <td>か</td>
                    <td>き</td>
                    <td>く</td>
                    <td>け</td>
                    <td>こ</td>
                </tr>
                <tr align="center">
                    <th><i>s</i></th>
                    <td>さ</td>
                    <td>し</td>
                    <td>す</td>
                    <td>せ</td>
                    <td>そ
                    </td>
                </tr>
                <tr align="center">
                    <th><i>t</i></th>
                    <td>た</td>
                    <td>ち</td>
                    <td>つ</td>
                    <td>て</td>
                    <td>と
                    </td>
                </tr>
                <tr align="center">
                    <th><i>n</i></th>
                    <td>な</td>
                    <td>に</td>
                    <td>ぬ</td>
                    <td>ね</td>
                    <td>の
                    </td>
                </tr>
                
            </tbody>
        </table>
            </div>
            <div class="col table-responsive">
                <table class="table mb-0" style="vertical-align:top" cellpadding="10" border="0">
                    <tbody>
                        <tr align="center">
                            <th></th>
                            <th><i>a</i></th>
                            <th><i>i</i></th>
                            <th><i>u</i></th>
                            <th><i>e</i></th>
                            <th><i>o</i></th>
                        </tr>
                        
                        <tr align="center">
                            <th><i>h</i></th>
                            <td>は</td>
                            <td>ひ</td>
                            <td>ふ</td>
                            <td>へ</td>
                            <td>ほ</td>
                        </tr>
                        <tr align="center">
                            <th><i>m</i></th>
                            <td>ま</td>
                            <td>み</td>
                            <td>む</td>
                            <td>め</td>
                            <td>も</td>
                        </tr>
                        <tr align="center">
                            <th><i>y</i></th>
                            <td>や</td>
                            <td class='emptyCell'></td>
                            <td>ゆ</td>
                            <td class='emptyCell'></td>
                            <td>よ</td>
                        </tr>
                        <tr align="center">
                            <th><i>r</i></th>
                            <td>ら</td>
                            <td>り</td>
                            <td>る</td>
                            <td>れ</td>
                            <td>ろ</td>
                        </tr>
                        <tr align="center">
                            <th><i>w</i></th>
                            <td>わ</td>
                            <td class='emptyCell'></td>
                            <td class='emptyCell'></td>
                            <td class='emptyCell'></td>
                            <td>を</td>
                        </tr>
                        <tr align="center">
                            <td colspan="6">ん<b>(<i>n</i>)</b></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        
        
    </div>
</template>
<script>
export default {
    name: 'Table',
    data(){
        return {

        }
    }
}
</script>
<style>
.table-responsive{
    font-size: 16px;
    color: #bd2d2d;
}

th, .emptyCell{
    background-color: #ffcece;
}

</style>



// WEBPACK FOOTER //
// src/components/table.vue